function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Link from 'components/Link';
import clinicShape from 'shapes/clinicShape';
import intlShape from 'shapes/intlShape';
import ClinicSettings from 'svg/clinic-settings.svg';
import messages from '../../messages';
import styles from './ClinicSettingsIconLink.pcss';
var _React_PureComponent;
class ClinicSettingsIconLink extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { organizationUID, name } = get(this.props.clinicMembership, 'clinic', {});
        return /*#__PURE__*/ _jsx(Link, {
            to: this.context.getUrl('clinic-settings', {
                clinicSlug: getSlug(name),
                organizationUID
            }),
            className: styles.link,
            "data-for": "globalTooltip",
            "data-tip": this.props.intl.formatMessage(messages.headers.clinicSettings),
            children: /*#__PURE__*/ _jsx(ClinicSettings, {
                className: styles.link__icon
            })
        });
    }
}
_define_property(ClinicSettingsIconLink, "contextType", AppContext);
_define_property(ClinicSettingsIconLink, "propTypes", {
    // Explicit props
    clinicMembership: PropTypes.shape({
        clinic: clinicShape
    }).isRequired,
    // Implicit props
    intl: intlShape
});
export default withStyles(styles)(injectIntl(ClinicSettingsIconLink));
